module.exports = __webpack_public_path__ + "img/demo_woman6.1c5b3b64.svg";